"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skins = [
    {
        name: 'Blue',
        value: 'skin-prolaera'
    },
    {
        name: 'Black',
        value: 'skin-black'
    },
    {
        name: 'Gray',
        value: 'skin-gray'
    },
    {
        name: 'Light Blue',
        value: 'skin-light-blue'
    },
    {
        name: 'Orange',
        value: 'skin-orange'
    },
    {
        name: 'White',
        value: 'skin-white'
    }
];
exports.skins = skins;
//# sourceMappingURL=skins.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/skins.js
// module id = 892
// module chunks = 0